module.exports = __webpack_public_path__ + "static/media/ic_pin.b46927d7.svg";